module.exports = __webpack_public_path__ + "static/img/mob-3.0f11e86c.jpeg";